
export const PAGES = {
  HOME: 'home',
  HR: 'hr',
  HR_CHAT: 'hr-chat',
  HR_JOB_POSTING_CHAT: 'hr-job-posting-chat',
  HR_VACATION: 'hr-vacation',
  TECHNOLOGY: 'technology',
  TECHNOLOGY_CHAT: 'technology-chat',
  PROCUREMENT: 'procurement',
  PROCUREMENT_CHAT: 'procurement-chat',
  TRAVEL: 'travel',
  TRAVEL_CHAT: 'travel-chat',
  FACILITIES: 'facilities',
  NOTIFICATIONS: 'notifications',
  MY_AGENTS: 'my-agents',
  AGENT_DETAILS: 'agent-details',
  SAVED: 'saved',
  RESOURCES: 'resources',
  OPEN_REQUEST_CHAT: 'open-request-chat',
  DEVKIT: 'devkit',
  ADMIN: 'admin',
  AGENT_CATALOG: 'agentCatalog',
  API_DOCUMENTATION: 'apiDocumentation',
  AGENTS: 'agents',
  CONVERSATIONS: 'conversations',
  CARDS_MOCKUP: 'cards-mockup',
} as const;

export type PageType = typeof PAGES[keyof typeof PAGES];
